(function() {
  function init() {
    var hero = document.getElementById('noxor-hero');
    if (!hero) return;

    var slides = hero.querySelectorAll('.noxor-hero__slide');
    var bars = hero.querySelectorAll('.noxor-hero__progress-bar');
    var current = 0;
    var total = slides.length;
    var autoplayTimer = null;
    var DURATION = 5000;

    function resetBars() {
      bars.forEach(function(bar) {
        bar.classList.remove('active');
        var fill = bar.querySelector('.noxor-hero__progress-fill');
        fill.style.transition = 'none';
        fill.style.width = '0%';
      });
    }

    function goTo(index) {
      slides[current].classList.remove('noxor-hero__slide--active');
      current = (index + total) % total;
      slides[current].classList.add('noxor-hero__slide--active');

      resetBars();
      void bars[current].offsetWidth;
      bars[current].classList.add('active');

      clearTimeout(autoplayTimer);
      autoplayTimer = setTimeout(function() {
        goTo(current + 1);
      }, DURATION);
    }

    // Progress bar click
    bars.forEach(function(bar, i) {
      bar.addEventListener('click', function() { goTo(i); });
    });

    // Pause on hover
    hero.addEventListener('mouseenter', function() { clearTimeout(autoplayTimer); });
    hero.addEventListener('mouseleave', function() {
      autoplayTimer = setTimeout(function() { goTo(current + 1); }, DURATION);
    });

    // Swipe mobile
    var touchStartX = 0;
    hero.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    hero.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // Init
    goTo(0);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
